import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class LevelSliderController implements angular.IComponentController, angular.IOnChanges {
    level: number;

    readonly maxLevel: number;
    readonly minLevel: number;
    readonly onChange: (value: { level: number }) => void;
    readonly selectedLevel: number;
    readonly title: string;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedLevel']) {
            this.level = this.selectedLevel;
            this.change();
        }
        if (changesObj['maxLevel']) {
            this.level = this.maxLevel;
            this.change();
        }
    }

    change() {
        if (this.onChange) {
            this.onChange({ level: this.level });
        }
    }
}

export const wtLevelSlider: ComponentDefinition = {
    componentId: 'wtLevelSlider',
    controller: LevelSliderController,
    template: require('./levelSlider.component.html'),
    controllerAs: 'vm',
    bindings: {
        title: '@',
        minLevel: '<',
        maxLevel: '<',
        onChange: '&?',
        selectedLevel: '<?'
    }
};
